export const GET_PAGE_DATA = "GET_PAGE_DATA";
export const GET_PAGE_DATA_SUCCESS = "GET_PAGE_DATA_SUCCESS";
export const GET_PAGE_DATA_FAILURE = "GET_PAGE_DATA_FAILURE";

// ==================================================
// ==================================================

export const GET_SECTION_DATA = "GET_SECTION_DATA";
export const GET_SECTION_DATA_SUCCESS = "GET_SECTION_DATA_SUCCESS";
export const GET_SECTION_DATA_FAILURE = "GET_SECTION_DATA_FAILURE";

// ==================================================
// ==================================================

export const GET_SETTINGS = "GET_SETTINGS";
export const GET_SETTINGS_SUCCESS = "GET_SETTINGS_SUCCESS";
export const GET_SETTINGS_FAILURE = "GET_SETTINGS_FAILURE";

// ==================================================
// ==================================================

export const CONTACT_US = "CONTACT_US";
export const CONTACT_US_SUCCESS = "CONTACT_US_SUCCESS";
export const CONTACT_US_FAILURE = "CONTACT_US_FAILURE";

// ==================================================
// ==================================================

export const GET_SERVICES = "GET_SERVICES";
export const GET_SERVICES_SUCCESS = "GET_SERVICES_SUCCESS";
export const GET_SERVICES_FAILURE = "GET_SERVICES_FAILURE";

// ==================================================
// ==================================================

export const GET_PROJECTS = "GET_PROJECTS";
export const GET_PROJECTS_SUCCESS = "GET_PROJECTS_SUCCESS";
export const GET_PROJECTS_FAILURE = "GET_PROJECTS_FAILURE";

// ==================================================
// ==================================================

export const GET_BLOGS = "GET_BLOGS";
export const GET_BLOGS_SUCCESS = "GET_BLOGS_SUCCESS";
export const GET_BLOGS_FAILURE = "GET_BLOGS_FAILURE";

// ==================================================
// ==================================================

export const GET_SINGLE_BLOG = "GET_SINGLE_BLOG";
export const GET_SINGLE_BLOG_SUCCESS = "GET_SINGLE_BLOG_SUCCESS";
export const GET_SINGLE_BLOG_FAILURE = "GET_SINGLE_BLOG_FAILURE";

// ==================================================
// ==================================================

export const SUBSCRIBE_NEWSLETTER = "SUBSCRIBE_NEWSLETTER";
export const SUBSCRIBE_NEWSLETTER_SUCCESS = "SUBSCRIBE_NEWSLETTER_SUCCESS";
export const SUBSCRIBE_NEWSLETTER_FAILURE = "SUBSCRIBE_NEWSLETTER_FAILURE";

// ==================================================
// ==================================================

export const GET_SOCIALS = "GET_SOCIALS";
export const GET_SOCIALS_SUCCESS = "GET_SOCIALS_SUCCESS";
export const GET_SOCIALS_FAILURE = "GET_SOCIALS_FAILURE";

// ==================================================
// ==================================================

export const GET_CLIENTS = "GET_CLIENTS";
export const GET_CLIENTS_SUCCESS = "GET_CLIENTS_SUCCESS";
export const GET_CLIENTS_FAILURE = "GET_CLIENTS_FAILURE";

// ==================================================
// ==================================================

export const GET_CONTACT_SECTION = "GET_CONTACT_SECTION";
export const GET_CONTACT_SECTION_SUCCESS = "GET_CONTACT_SECTION_SUCCESS";
export const GET_CONTACT_SECTION_FAILURE = "GET_CONTACT_SECTION_FAILURE";

// ==================================================
// ==================================================

export const GET_BLOG_CATEGORIES = "GET_BLOG_CATEGORIES";
export const GET_BLOG_CATEGORIES_SUCCESS = "GET_BLOG_CATEGORIES_SUCCESS";
export const GET_BLOG_CATEGORIES_FAILURE = "GET_BLOG_CATEGORIES_FAILURE";

// ==================================================
// ==================================================

export const GET_SINGLE_CATEGORY = "GET_SINGLE_CATEGORY";
export const GET_SINGLE_CATEGORY_SUCCESS = "GET_SINGLE_CATEGORY_SUCCESS";
export const GET_SINGLE_CATEGORY_FAILURE = "GET_SINGLE_CATEGORY_FAILURE";

// ==================================================
// ==================================================

export const GET_BLOGS_BY_CATEGORY = "GET_BLOGS_BY_CATEGORY";
export const GET_BLOGS_BY_CATEGORY_SUCCESS = "GET_BLOGS_BY_CATEGORY_SUCCESS";
export const GET_BLOGS_BY_CATEGORY_FAILURE = "GET_BLOGS_BY_CATEGORY_FAILURE";

// ==================================================
// ==================================================

export const LOAD_MORE_BLOGS = "LOAD_MORE_BLOGS";
export const LOAD_MORE_BLOGS_SUCCESS = "LOAD_MORE_BLOGS_SUCCESS";
export const LOAD_MORE_BLOGS_FAILURE = "LOAD_MORE_BLOGS_FAILURE";

// ==================================================
// ==================================================

export const GET_PROJECT_TYPES = "GET_PROJECT_TYPES";
export const GET_PROJECT_TYPES_SUCCESS = "GET_PROJECT_TYPES_SUCCESS";
export const GET_PROJECT_TYPES_FAILURE = "GET_PROJECT_TYPES_FAILURE";

// ==================================================
// ==================================================
